import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ForceCacheClearService {

  /**
   * Ejecuta una limpieza forzada completa del navegador
   * Útil para casos donde la limpieza automática no funciona
   */
  forceClearAll(): void {
    console.info('Iniciando limpieza forzada completa...');
    
    try {
      // 1. Limpiar todo el localStorage
      localStorage.clear();
      
      // 2. Limpiar todo el sessionStorage
      sessionStorage.clear();
      
      // 3. Limpiar todas las cookies
      this.clearAllCookies();
      
      // 4. Limpiar IndexedDB
      this.clearIndexedDB();
      
      // 5. Limpiar WebSQL (si está disponible)
      this.clearWebSQL();
      
      // 6. Limpiar cache del navegador
      this.clearBrowserCaches();
      
      // 7. Desregistrar service workers
      this.unregisterServiceWorkers();
      
      console.info('Limpieza forzada completada');
      
      // 8. Recargar la página con cache busting
      this.forceReload();
      
    } catch (error) {
      console.error('Error en limpieza forzada:', error);
      // Fallback: recargar la página
      window.location.reload();
    }
  }

  private clearAllCookies(): void {
    document.cookie.split(';').forEach(cookie => {
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
      if (name) {
        // Eliminar con diferentes configuraciones de path y domain
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;`;
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${window.location.hostname};`;
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.${window.location.hostname};`;
      }
    });
  }

  private clearIndexedDB(): void {
    if ('indexedDB' in window) {
      indexedDB.databases().then(databases => {
        databases.forEach(db => {
          if (db.name) {
            indexedDB.deleteDatabase(db.name);
          }
        });
      }).catch(err => {
        console.warn('No se pudo limpiar IndexedDB:', err);
      });
    }
  }

  private clearWebSQL(): void {
    // WebSQL está deprecated pero algunos navegadores viejos lo usan
    try {
      if ('openDatabase' in window) {
        const db = (window as any).openDatabase('', '', '', '');
        db.transaction((tx: any) => {
          tx.executeSql('DROP TABLE IF EXISTS data');
        });
      }
    } catch (error) {
      console.warn('No se pudo limpiar WebSQL:', error);
    }
  }

  private clearBrowserCaches(): void {
    if ('caches' in window) {
      caches.keys().then(cacheNames => {
        return Promise.all(
          cacheNames.map(cacheName => caches.delete(cacheName))
        );
      }).then(() => {
        console.info('Cache API limpiado');
      }).catch(err => {
        console.warn('Error limpiando Cache API:', err);
      });
    }
  }

  private unregisterServiceWorkers(): void {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.forEach(registration => {
          registration.unregister();
        });
      }).catch(err => {
        console.warn('Error desregistrando service workers:', err);
      });
    }
  }

  private forceReload(): void {
    // Agregar parámetros únicos para evitar cualquier tipo de cache
    const url = new URL(window.location.href);
    url.searchParams.set('_clearCache', Date.now().toString());
    url.searchParams.set('_forceReload', Math.random().toString(36).substr(2, 9));
    
    // Usar replace para evitar que se pueda volver atrás
    window.location.replace(url.toString());
  }

  /**
   * Método para llamar desde la consola del navegador en casos de emergencia
   */
  emergencyClear(): void {
    console.info('EJECUTANDO LIMPIEZA DE EMERGENCIA - NO CERRAR ESTA PESTAÑA');
    
    // Limpieza más agresiva
    this.forceClearAll();
    
    // Si después de 3 segundos no se ha recargado, forzar recarga dura
    setTimeout(() => {
      console.info('Ejecutando recarga de emergencia...');
      window.location.href = window.location.href.split('?')[0] + '?_emergency=' + Date.now();
    }, 3000);
  }
}
